function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Grupo_675",
  "data-name": "Grupo 675",
  transform: "translate(3055 -69)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Icon_ionic-ios-checkmark-circle-outline",
  "data-name": "Icon ionic-ios-checkmark-circle-outline",
  transform: "translate(-3055 69)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Trazado_1458",
  "data-name": "Trazado 1458",
  d: "M46.875,9.231A37.65,37.65,0,0,1,73.5,73.5,37.65,37.65,0,0,1,20.252,20.252,37.4,37.4,0,0,1,46.875,9.231m0-5.856a43.5,43.5,0,1,0,43.5,43.5,43.493,43.493,0,0,0-43.5-43.5Z",
  transform: "translate(-3.375 -3.375)"
})), /*#__PURE__*/React.createElement("g", {
  id: "Icon_feather-check-circle",
  "data-name": "Icon feather-check-circle",
  transform: "translate(-3031.361 98.615)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Trazado_1462",
  "data-name": "Trazado 1462",
  d: "M55.439,6,23.178,38.952,13.5,29.076",
  transform: "translate(-13.5 -6)",
  fill: "none",
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 7
})));

var SvgCheckmarkOverview = function SvgCheckmarkOverview(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 87,
    height: 87,
    viewBox: "0 0 87 87",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCheckmarkOverview, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/checkmark_overview.c1cd7416.svg";
export { ForwardRef as ReactComponent };